import React from 'react';
import { UniverSimpleTest } from '../test/UniverSimpleTest';

export const UniverTestPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' }}>
      <UniverSimpleTest />
    </div>
  );
};
















